/**
 * @class YouTube Video
 *
 * @method constructor
 *     @param {HTMLElement} el
 *
 * @method onPlayerReady
 * @method playVideo
 * @method pauseVideo
 * @method setToggleText
 * @method init
 *
 * Create a YouTube iframe
 */

const selectors = {
  container: '.js-video-container',
  trigger: '.js-video-trigger',
};

const classes = {
  playing: 'is-playing',
  ready: 'is-ready',
};

export default class YouTubeVideo {
  constructor(el) {
    this.el = el;
    this.container = el.querySelector(selectors.container);
    this.trigger = el.querySelector(selectors.trigger);
    this.player = null;

    this.isPlaying = false;
    this.autoplay = this.el.dataset.autoplay === 'true';
    this.loop = this.el.dataset.loop === 'true';

    this.init();
  }

  onPlayerReady(e) {
    this.el.classList.add(classes.ready);
    this.player = e.target;
    this.trigger.addEventListener('click', () => {
      this.playVideo();
    });

    if (this.autoplay) {
      setTimeout(() => {
        this.el.classList.add(classes.playing);
        this.isPlaying = true;
      }, 4000);
    }
  }

  playVideo() {
    if (!this.player) return;

    this.player.playVideo();
    this.el.classList.add(classes.playing);
    this.isPlaying = true;
  }

  pauseVideo() {
    if (!this.player) return;

    this.player.pauseVideo();
    this.el.classList.remove(classes.playing);
    this.isPlaying = false;
  }

  setToggleText() {
    this.label.innerText = this.isOpen
      ? this.toggle.dataset.closeText
      : this.toggle.dataset.openText;
  }

  init() {
    this.container.ytPlayer = new window.YT.Player(this.container, {
      playerVars: {
        playsinline: 1,
      },
      events: {
        onReady: this.onPlayerReady.bind(this),
      },
    });
  }
}
